var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"img-button",class:{disabled:_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }